import React, { useEffect } from 'react';
import $ from 'jquery';
import '../styles/AboutSection.css';

const AboutSection: React.FC = () => {
  useEffect(() => {
    // Fade in elements when they come into view
    $(window).on('scroll', function() {
      $('.fade-in').each(function() {
        const elementTop = $(this).offset()?.top || 0;
        const windowBottom = $(window).scrollTop()! + $(window).height()!;
        
        if (windowBottom > elementTop) {
          $(this).addClass('visible');
        }
      });
    });
  }, []);

  return (
    <section className="about-section">
      <div className="about-content">
        <h2 className="fade-in">Rólam</h2>
        <div className="about-grid">
          <div className="about-text-content fade-in">
            <div className="about-text">
              <p>
                <b>Pelyák Adél – Kéz- és lábápoló, műkörömépítő.</b>
              </p>
              <p>
                Üdvözöllek! Pelyák Adél vagyok, Titan System, Sub. Titan System körömszabályzó és Top Side Clip Orthonyxie Spange okleveles specialista. Fő profilom a gyógyászati pedikűr és manikűr, melynek célja nemcsak az esztétikum, hanem a láb- és kézegészség megőrzése, illetve helyreállítása.
              </p>
              <p>
                2019 óta foglalkozom kéz- és lábápolással, és azóta folyamatosan képzem magam, hogy a legmodernebb technikákkal és megoldásokkal segíthessek vendégeimnek. A gyógyászati pedikűr különösen fontos számomra, hiszen megelőzhetünk, vagy ha már kialakult, akkor kezelhetünk vele komolyabb problémákat, mint például körömgomba, tyúkszem vagy bőrkeményedés. Akár idős hozzátartozódnak van szüksége kezelésre, akár Te szeretnéd rendbe hozni körmeid állapotát, bizalommal fordulhatsz hozzám.
              </p>
              <p>
              Célom, hogy minden vendég elégedetten távozzon, egészséges bőrrel és ápolt körmökkel – kompromisszumok nélkül. Várlak szeretettel egyéni igényeidre szabott, professzionális kezelésekkel, immár két helyszínen: a 16. kerületi Nailsroomban és a 13. kerületben található Teola Salonban!              
              </p>
            </div>
          </div>
          <div className="about-image-container fade-in">
            <div className="image-placeholder">
              <div className="image-frame">
                <img 
                  src="/images/self-image.jpeg" 
                  alt="Pelyák Adél" 
                  className="about-image"
                />
              </div>
            </div>
          </div>
        </div>
        
        <div className="features-container fade-in">
          <div className="features-grid">
            <div className="feature">
              <span className="feature-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7.75 12L10.58 14.83L16.25 9.17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <h3>Professzionális gondoskodás</h3>
            </div>
            <div className="feature">
              <span className="feature-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9 9H9.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15 9H15.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <h3>Kellemes környezet</h3>
            </div>
            <div className="feature">
              <span className="feature-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <h3>Gyönyörű eredmények</h3>
            </div>
            <div className="feature">
              <span className="feature-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.5 13.75C9.5 14.72 10.25 15.5 11.17 15.5H13.05C13.85 15.5 14.5 14.82 14.5 13.97C14.5 13.06 14.1 12.73 13.51 12.52L10.5 11.47C9.91 11.26 9.51001 10.94 9.51001 10.02C9.51001 9.17999 10.16 8.48999 10.96 8.48999H12.84C13.76 8.48999 14.51 9.26999 14.51 10.24" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 7.5V16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <h3>Kedvező árak</h3>
            </div>
            <div className="feature">
              <span className="feature-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 15C15.7279 15 18.75 12.0899 18.75 8.5C18.75 4.91015 15.7279 2 12 2C8.27208 2 5.25 4.91015 5.25 8.5C5.25 12.0899 8.27208 15 12 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 13L7 20M17 13L17 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <h3>Személyre szabott kezelések</h3>
            </div>
            <div className="feature">
              <span className="feature-icon">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15.6947 13.7H15.7037" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15.6947 16.7H15.7037" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M11.9955 13.7H12.0045" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M11.9955 16.7H12.0045" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8.29431 13.7H8.30329" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8.29431 16.7H8.30329" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <h3>Rugalmas időpontok</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 